import { useTranslation } from 'react-i18next';

import { UseMutationResult } from '@tanstack/react-query';

import { ErrorDisplay } from '../../../../../Shared/components/ErrorDisplay/ErrorDisplay';
import { ApiError } from '../../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../../Shared/interfaces/ApiResponse';
import { CustomButtonColor } from '../../../../../UiComponentsLibrary/CustomButton/constants/CustomButtonColor';
import { CustomConfirmationModal } from '../../../../../UiComponentsLibrary/CustomConfirmationModal';
import { QueueSheetManagementRows } from '../../interface/QueueSheetInterface';

interface BookingConfirmationModalProps {
  isDeleteModalOpen: boolean;
  bookingToDelete: QueueSheetManagementRows | null;
  handleDeleteConfirm: () => void;
  handleDeleteCancel: () => void;
  deleteBookingMutation: UseMutationResult<
    ApiResponseKeys,
    ApiError,
    string,
    unknown
  >;
}

const BookingConfirmationModal = ({
  isDeleteModalOpen,
  bookingToDelete,
  handleDeleteConfirm,
  handleDeleteCancel,
  deleteBookingMutation,
}: BookingConfirmationModalProps) => {
  const { t } = useTranslation();
  return (
    <CustomConfirmationModal
      isOpen={isDeleteModalOpen}
      title={t('delete-booking-modal-title')}
      message={t('delete-booking-confirmation-message', {
        brand: bookingToDelete?.brand,
        entryId: bookingToDelete?.entryId,
      })}
      onConfirmCb={handleDeleteConfirm}
      onCancelCb={handleDeleteCancel}
      confirmButtonText={
        deleteBookingMutation.isPending
          ? t('delete-user-modal-button-loading-text')
          : t('delete-button')
      }
      confirmButtonDisabled={deleteBookingMutation.isPending}
      confirmButtonColor={CustomButtonColor.delete}
    >
      {deleteBookingMutation.error && (
        <ErrorDisplay error={deleteBookingMutation.error} />
      )}
    </CustomConfirmationModal>
  );
};

export default BookingConfirmationModal;
